import module from '../bahabot.module'

module.filter('bbExecutionStatus', () => {
    return function(input) {
        // For now we just to ucfirst
        return input ? (input[0].toUpperCase() + input.substring(1)) : "N/A";
    };
})